<template>
  <v-app aria-label="RISE Partner Incentive Program">
    <div id="skip-links-portal"></div>
    <v-main id="app-main" role="main" aria-label="Main application content">
      <router-view v-slot="{ Component, route }">
        <transition name="router-anim">
          <component :is="Component" :key="route.path" />
        </transition>
      </router-view>
      <v-dialog theme="dark" v-model="httpStore.showLoading" max-width="320" persistent role="dialog" aria-labelledby="loading-dialog-title" aria-describedby="loading-dialog-description" id="loading-dialog" :focus-trap="true" :retain-focus="false" aria-modal="true">
        <v-list class="py-2" color="primary" elevation="12" rounded="lg" role="presentation">
          <v-list-item id="loading-dialog-title" title="Processing Request..." tabindex="0" role="status" aria-live="polite">
            <template v-slot:prepend>
              <div class="pe-4">
                <v-img :src="dell_logo" width="40" alt="Dell Technologies Partner Program Logo" />
              </div>
            </template>

            <template v-slot:append>
              <v-progress-circular color="primary" indeterminate="disable-shrink" size="16"
                width="2" aria-label="Loading in progress" role="status" aria-live="polite"></v-progress-circular>
            </template>
          </v-list-item>
        </v-list>
      </v-dialog>
      <!-- <v-overlay :model-value="httpStore.showLoading" class="align-center justify-center">
        <v-sheet class="text-center pa-4" :elevation="10" rounded :width="200" color="rgb(255,255,255,1)">
          <v-progress-circular color="primary" size="64" indeterminate></v-progress-circular>
          <v-sheet class="mt-4" color="transparent">Processing request</v-sheet>
        </v-sheet>

      </v-overlay> -->
      <!-- <v-snackbar theme="light"  v-model="systemStore.messageVisible" color="deep-purple-accent-4"
      elevation="24">Bla</v-snackbar> -->
      <v-snackbar class="pa-0" elevation="24" theme="light" content-class="snackbar-style"
        :color="systemStore.messageColor" timer="white" location="top" v-model="systemStore.messageVisible"
        :timeout="systemStore.messageTimeout" role="alert" aria-live="assertive" id="notifications">
        <template v-slot:text class="pa-0 ma-0">
          <div role="log" aria-live="assertive" aria-label="Application notifications">
            <v-alert tile class="ma-0" theme="light" v-for="(msg, index) in systemStore.messageList" :key="index" :text="msg"
              :type="systemStore.messageColor" role="status" :aria-label="`Notification ${index + 1}: ${msg}`"></v-alert>
          </div>
        </template>
        <template v-slot:actions>
          <v-btn class="ml-2" :color="systemStore.messageColor" variant="elevated"
            @click="systemStore.messageVisible = false" @keydown.enter="systemStore.messageVisible = false" 
            @keydown.space.prevent="systemStore.messageVisible = false" aria-label="Close notification" tabindex="0">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script setup>
import './assets/base.css'
import { ref, onMounted } from 'vue'
import { useHttpStore } from '@/stores/http'
import { useSystemStore } from '@/stores/system'
import { useAuthStore } from '@/stores/auth'
import dell_logo from '@/assets/img/logo/dell_logo.png'

const httpStore = useHttpStore()
const systemStore = useSystemStore()
const authStore = useAuthStore()


onMounted(() => {



  const pageAccessedByReload = (
    (window.performance.navigation && window.performance.navigation.type === 1) ||
    window.performance
      .getEntriesByType('navigation')
      .map((nav) => nav.type)
      .includes('reload')
  );

  if (pageAccessedByReload) {
    var ast = sessionStorage.getItem('assets')
    systemStore.storeData.assets = ast
  } else {
    systemStore.setData('assets', {})
    sessionStorage.setItem('assets', {})
  }

  systemStore.reloadAllData()

  httpStore.token = sessionStorage.getItem("accessToken");
  if (httpStore.token != null && httpStore.token.trim().length > 0) {
    systemStore.getUserDetails().then(res => {
      systemStore.userDetail = res.userDetail
    })
      .catch(error => {
        sessionStorage.setItem("accessToken", '');

        httpStore.token = "";
        systemStore.routerTo('login')
      })
  }

})

/* const reloadAllData = () => {
  httpStore.apiAll([
    systemStore.getElementLinks(),
    systemStore.getAllLanguages(),
    systemStore.getLanguageDictionary()]
  ).then(result => {
    systemStore.selectedLanguage = ''
    systemStore.defaultDataLoaded = true

    var lsLanguage = localStorage.getItem("selectedLanguage")
    systemStore.selectedLanguage = lsLanguage == null || lsLanguage == '' ? 'en' : lsLanguage
    localStorage.setItem("selectedLanguage", systemStore.selectedLanguage)
  }).catch(error => {
    var t = error
  })
} */


// deprecated way of checking page reloaded
// if (window.performance) {
//   console.info("window.performance works fine on this browser");
// }
// console.info(performance.navigation.type);
// if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
//   console.info( "This page is reloaded" );
// } else {
//   console.info( "This page is not reloaded");
// }

// new way of checking if pagr was reloaded


</script>

<style>
/* Global skip link styles — rendered via Teleport from each view */
.skip-link {
  position: absolute;
  top: -40px;
  left: 6px;
  background: #000000;
  color: #ffffff;
  padding: 8px 12px;
  text-decoration: none;
  z-index: 9999;
  border-radius: 4px;
  font-weight: bold;
  transition: top 0.3s;
}

.skip-link:focus {
  top: 6px;
  outline: 5px solid #FFD700;
  outline-offset: 3px;
  box-shadow: 0 0 0 10px rgba(255, 215, 0, 0.6);
}

@media (prefers-reduced-motion: reduce) {
  .skip-link {
    transition: none !important;
  }
}

.snackbar-style {
  padding: 0px;
}

#body {
  font-family: "Roboto", sans-serif;
  ;
}

v-app {
  position: fixed;
  width: inherit;
}

.router-anim-enter-active {
  animation: coming 100ms;
  animation-delay: 150ms;
  opacity: 0;
}

.router-anim-leave-active {
  animation: going 100ms;
}

/* Reduced motion support for accessibility */
@media (prefers-reduced-motion: reduce) {
  .router-anim-enter-active,
  .router-anim-leave-active {
    animation: none !important;
    transition: opacity 0.1s ease-in-out !important;
  }
  
  .router-anim-enter-active {
    opacity: 1 !important;
  }
  
  .router-anim-leave-active {
    opacity: 0 !important;
  }
}

/* WCAG 2.0 Focus Indicators - 3:1 Contrast Ratio */
:deep(.v-btn:focus-visible) {
  outline: 4px solid #FFD700 !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 7px rgba(255, 215, 0, 0.5) !important;
  position: relative !important;
  z-index: 10 !important;
}

:deep(.v-dialog:focus-visible) {
  outline: 4px solid #FFD700 !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 7px rgba(255, 215, 0, 0.4) !important;
}

:deep(.v-snackbar:focus-visible) {
  outline: 4px solid #FFD700 !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 7px rgba(255, 215, 0, 0.4) !important;
}

:deep(.v-list-item:focus-visible) {
  outline: 3px solid #FFD700 !important;
  outline-offset: 2px !important;
  background-color: rgba(255, 215, 0, 0.2) !important;
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  :deep(.v-btn:focus-visible),
  :deep(.v-dialog:focus-visible),
  :deep(.v-snackbar:focus-visible) {
    outline-width: 5px !important;
    outline-color: #FFFF00 !important;
    box-shadow: 0 0 0 9px rgba(255, 255, 0, 0.6) !important;
  }
}

@keyframes going {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }

  to {
    transform: translateX(0px);
    opacity: 10;
  }
}
</style>